export const ImpersonatedShopHeaderName = 'x-impersonated-shop';
